// Modal.js
import React from "react";
import styles from "./modalEndGame.module.css";

const ModalEndGame = ({ onClose, onCancel }) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>ยืนยันการประเมิน</h2>
        <p>นี่คือผลการประเมินเบื้องต้น กลับมาเล่นให้ครบ 5 เกมเพื่อความแม่นยําสูงสุด</p>
        <button className={styles.buttonCloseModal} onClick={onCancel}>ยกเลิก</button>
        <button className={styles.buttonExitGame} onClick={onClose}>ยืนยัน</button>
      </div>
    </div>
  );
};

export default ModalEndGame;
